// api/availability.js
import axios from "axios";
import api from "./axios";

const PROVIDERS_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1/providers`;
const SEARCH_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1/providers/search`;

// ---------- Availability (CRUD-ish) ----------

// Create availability (and generate slots)
export const createAvailability = async (providerId, availabilityDTO) => {
  const response = await api.post(
    `${PROVIDERS_BASE}/${providerId}/availabilities`,
    availabilityDTO,
  );
  return response.data;
};

// Get FREE start-times for a day (ZonedDateTime strings in requested zone)
export const getFreeStartTimes = async (
  providerId,
  { date, zone, telehealth } = {},
) => {
  const response = await api.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/start-times`,
    { params: { date, zone, telehealth } },
  );
  return response.data;
};

// ---------- NEW: Get provider's availability for *today* (per-provider) ----------
// Endpoint: GET http://localhost:8080/api/providers/{providerId}/availabilities/today
// Returns an array of slot objects (or an empty array). Optional `zone` param for display zone.
export const getProviderAvailabilityToday = async (
  providerId,
  { zone } = {},
) => {
  const params = {};
  if (zone) params.zone = zone;

  const response = await axios.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/today`,
    { params },
  );
  return response.data;
};

/*export const getProviderAvailabilityToday = async (
  providerId,
  { zone } = {},
) => {
  const params = {
    zone: zone || "America/New_York", // Default to EST/EDT
  };

  const response = await api.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/today`,
    { params },
  );
  return response.data;
};*/

//GET BOOKED FREE start times for a day
/*export const getFreeStartTimesBooked = async (
  providerId,
  { date, zone, telehealth } = {},
) => {
  const response = await api.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/start-times/booked`,
    { params: { date, zone, telehealth } },
  );
  return response.data;
};*/

export async function getFreeStartTimesBooked(
  providerId,
  { date, zone, telehealth } = {},
) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (zone) params.set("zone", zone);
  if (telehealth !== undefined && telehealth !== null) {
    params.set("telehealth", String(telehealth));
  }

  const res = await api.get(
    `/api/v1/providers/${providerId}/availabilities/start-times/booked?${params.toString()}`,
  );

  // ✅ Now returns [{ start: "...", appointmentId: 123 }, ...]
  return res.data;
}

// Get start and end time for slots during appt booking
//and listing
export const getSlotsByDate = async (
  providerId,
  { date, zone, telehealth, status } = {},
) => {
  const res = await api.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/slots`,
    { params: { date, zone, telehealth, status } },
  );
  return res.data; // [{ slotId, availabilityId, slotStart, slotEnd, telehealth, status }]
};

// api/availability.js (add)
export const getAvailabilityInfoByStart = async (
  providerId,
  { start, zone },
) => {
  const res = await api.get(
    `${PROVIDERS_BASE}/${providerId}/availabilities/lookup-by-start`,
    { params: { start, zone } },
  );
  return res.data;
};

// Update availability window and/or telehealth
export const updateAvailability = async (
  providerId,
  availabilityId,
  updateDTO,
) => {
  const response = await api.put(
    `${PROVIDERS_BASE}/${providerId}/availabilities/${availabilityId}`,
    updateDTO,
  );
  return response.data;
};

// APIs/availability.js
export const getAvailabilityById = async (
  providerId,
  availabilityId,
  { zone },
) => {
  const res = await api.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/providers/${providerId}/availabilities/${availabilityId}`,
    { params: { zone } },
  );
  return res.data;
};

// Delete availability
export const deleteAvailability = async (providerId, availabilityId) => {
  const response = await api.delete(
    `${PROVIDERS_BASE}/${providerId}/availabilities/${availabilityId}`,
  );
  return response.data; // 204 -> usually undefined
};

// ---------- Provider search (Today / Time range / Telehealth) ----------

// Search providers by date (full day in zone)
// telehealth: true = telehealth-only, false = in-person-only, omitted = either
export const searchProvidersByDate = async ({
  date,
  zone,
  telehealth,
} = {}) => {
  const response = await api.get(SEARCH_BASE, {
    params: { date, zone, telehealth },
  });
  return response.data; // number[] of providerIds
};

// Search providers by date + time range (strict bounds on that day)
// from/to format: "HH:mm" on a 15-minute grid
export const searchProvidersByDateRange = async ({
  date,
  from,
  to,
  zone,
  telehealth,
} = {}) => {
  const response = await api.get(SEARCH_BASE, {
    params: { date, from, to, zone, telehealth },
  });
  return response.data; // number[] of providerIds
};

// Convenience: search providers "today" in a zone (optionally with time range/telehealth)
export const searchProvidersToday = async ({
  from,
  to,
  zone,
  telehealth,
} = {}) => {
  const response = await api.get(`${SEARCH_BASE}/today`, {
    params: { from, to, zone, telehealth },
  });
  return response.data; // number[] of providerIds
};
